import { useEffect, useRef } from "react";
import api from "@/lib/api";
import { toast } from "sonner";

const POLL_MS = 30000;

export default function NovaOfertaSound() {
  const conhecidas = useRef(null);
  const audioRef = useRef(null);
  const desbloqueado = useRef(false);
  const iniciado = useRef(false);

  useEffect(() => {
    if (iniciado.current) return;
    iniciado.current = true;
    audioRef.current = new Audio("/sounds/montaja-nova-montagem.mp3");
    audioRef.current.preload = "auto";
    audioRef.current.volume = 0.7;
    // Navegadores exigem 1ª interação do usuário para liberar áudio
    const unlock = () => {
      if (desbloqueado.current) return;
      desbloqueado.current = true;
      const a = audioRef.current;
      a.muted = true;
      a.play().then(() => { a.pause(); a.currentTime = 0; a.muted = false; }).catch(() => { a.muted = false; });
      window.removeEventListener("pointerdown", unlock);
      window.removeEventListener("keydown", unlock);
    };
    window.addEventListener("pointerdown", unlock);
    window.addEventListener("keydown", unlock);

    const checar = async () => {
      try {
        const r = await api.get("/servicos", { params: { status: "aguardando_aceite_tecnico" } });
        const ids = new Set((r.data || []).filter(s => !s.montador_id).map(s => s.id));
        if (conhecidas.current === null) {
          conhecidas.current = ids;
          return;
        }
        const novas = [...ids].filter(id => !conhecidas.current.has(id));
        conhecidas.current = ids;
        if (novas.length > 0) {
          if (localStorage.getItem("mj_som_alertas") !== "0") {
            audioRef.current?.play().catch(() => {});
          }
          toast.success(novas.length === 1
            ? "Nova montagem disponível!"
            : `${novas.length} novas montagens disponíveis!`,
            { duration: 8000 });
        }
      } catch { /* silencioso */ }
    };
    checar();
    const timer = setInterval(checar, POLL_MS);
    return () => {
      clearInterval(timer);
      window.removeEventListener("pointerdown", unlock);
      window.removeEventListener("keydown", unlock);
    };
  }, []);

  return null;
}
